/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgAutomotiveTools32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M10.316 12.762a5.052 5.052 0 01-5.394-1.151A5.053 5.053 0 013.817 6.1c.078-.188.32-.225.463-.082l3.117 3.117 2.121-2.121-3.117-3.117c-.143-.144-.105-.386.082-.464a5.054 5.054 0 015.51 1.106 5.052 5.052 0 011.151 5.393l11.932 11.932a3.528 3.528 0 012.921 1.02c1.366 1.366 1.397 3.552.07 4.88-1.328 1.327-3.514 1.295-4.88-.07a3.524 3.524 0 01-.999-3.06L10.316 12.761z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M27.794 2.534l.387.387 1.591 1.59.388.388-.251.487-1.692 3.281-.47.913-.727-.726-.178-.178-7.75 7.75-1.06-1.061 7.749-7.75-.703-.702-7.553 7.615-1.065-1.056 7.557-7.62-.18-.18-.727-.726.914-.47 3.283-1.692.487-.25zm-2.17 2.804l1.73 1.73.97-1.883-.817-.816-1.883.97zM13.746 15.17l-.53-.53-.531.53.53.53-.53-.53-.001.001-.003.003-.012.012-.046.047-.18.179-.66.66-2.181 2.181-5.082 5.082a2.75 2.75 0 000 3.89c.37.368.767.765 1.136 1.135l.006.006a2.75 2.75 0 003.89 0l5.081-5.081 2.182-2.182.66-.66.179-.179.046-.047.012-.012.003-.003h.001l-.53-.53.53.53.53-.53-.53-.531-3.97-3.97zm-.901 1.962l.37-.37-4.724 10.543a1.252 1.252 0 01-1.768 0l-1.142-1.141a1.252 1.252 0 010-1.768l5.082-5.082 2.182-2.182zm.37-.37L8.491 27.303l5.081-5.081 2.182-2.182.371-.37-2.91-2.91z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M13.02 19.844l-3.547 3.524'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M26.355 24.576a1 1 0 11-1.414 1.414 1 1 0 011.414-1.414z'
      />
    </svg>
  );
}

export default SvgAutomotiveTools32;
